module.exports = __webpack_public_path__ + "img/PA.59b629e6.svg";